<style>
    /* Absolute Center Spinner */
    .loading {
      position: fixed;
      z-index: 999;
      height: 2em;
      width: 2em;
      overflow: show;
      margin: auto;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
    }
    
    /* Transparent Overlay */
    .loading:before {
      content: '';
      display: block;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
        background: radial-gradient(rgba(20, 20, 20,.8), rgba(0, 0, 0, .8));
    
      background: -webkit-radial-gradient(rgba(20, 20, 20,.8), rgba(0, 0, 0,.8));
    }
    
    /* :not(:required) hides these rules from IE9 and below */
    .loading:not(:required) {
      /* hide "loading..." text */
      font: 0/0 a;
      color: transparent;
      text-shadow: none;
      background-color: transparent;
      border: 0;
    }
    
    .loading:not(:required):after {
      content: '';
      display: block;
      font-size: 10px;
      width: 1em;
      height: 1em;
      margin-top: -0.5em;
      -webkit-animation: spinner 150ms infinite linear;
      -moz-animation: spinner 150ms infinite linear;
      -ms-animation: spinner 150ms infinite linear;
      -o-animation: spinner 150ms infinite linear;
      animation: spinner 150ms infinite linear;
      border-radius: 0.5em;
      -webkit-box-shadow: rgba(255,255,255, 0.75) 1.5em 0 0 0, rgba(255,255,255, 0.75) 1.1em 1.1em 0 0, rgba(255,255,255, 0.75) 0 1.5em 0 0, rgba(255,255,255, 0.75) -1.1em 1.1em 0 0, rgba(255,255,255, 0.75) -1.5em 0 0 0, rgba(255,255,255, 0.75) -1.1em -1.1em 0 0, rgba(255,255,255, 0.75) 0 -1.5em 0 0, rgba(255,255,255, 0.75) 1.1em -1.1em 0 0;
    box-shadow: rgba(255,255,255, 0.75) 1.5em 0 0 0, rgba(255,255,255, 0.75) 1.1em 1.1em 0 0, rgba(255,255,255, 0.75) 0 1.5em 0 0, rgba(255,255,255, 0.75) -1.1em 1.1em 0 0, rgba(255,255,255, 0.75) -1.5em 0 0 0, rgba(255,255,255, 0.75) -1.1em -1.1em 0 0, rgba(255,255,255, 0.75) 0 -1.5em 0 0, rgba(255,255,255, 0.75) 1.1em -1.1em 0 0;
    }
    
    /* Animation */
    
    @-webkit-keyframes spinner {
      0% {
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
      }
      100% {
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }
    @-moz-keyframes spinner {
      0% {
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
      }
      100% {
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }
    @-o-keyframes spinner {
      0% {
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
      }
      100% {
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }
    @keyframes spinner {
      0% {
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
      }
      100% {
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }
  
    
    </style>
  
  
  <div  class="loading" id="bestgiftsloader" style="display: none;">Loading&#8230;</div>


<div  class="order-confirm-page">
    <app-alerts *ngIf="showalertmsg"></app-alerts>
    <section class="order-confirm">

        <i class="fa fa-check-circle" style="font-size: 60px;color: #90ba4c;"></i>
        <span *ngIf="CONFIG.title != 'Karupattiraja'" class="thanks">We have received your Payment</span>
        <span *ngIf="CONFIG.title === 'Karupattiraja'" class="thanks">Your Order will be delivered in 5-7 working days</span>
        <span class="order-info">A copy of your receipt has been sent to your mail.</span>
        <span>Your Order Number is <b>{{orderNumer}}</b>.</span>
        <br>
    </section>
    <hr>
    <br>
    <section>
        <div class="row">
            <div class="row col-md-8" style="margin-left: 5px; margin-right: 5px;">
                <!-- <div class="col-sm-1">
                </div> -->
                <div class="col-sm-5">
                    <div class="card">
                        <br>
                        <br>
                        <!-- <h5>Delivery Details</h5> -->
                        <!-- <div *ngIf="shippingAddress !== '' && this.paymentMethod !== 'Pay In Store'">
                            <div class="row">
                                <div class="col">
                                    {{shippingAddress.name}}
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    {{shippingAddress.address1}}
                                    {{shippingAddress.landmark}}
                                    {{shippingAddress.entire_location}}
                                </div>
                            </div>
                        </div> -->
                        <!-- <span *ngIf="deliveryType==='PickUp In Store'" style="font-weight: bold;">Delivery Type - {{deliveryType}}</span> -->
                    </div>
                </div>
                <div class="col-sm-5">
                    <div class="card">
                        <br>
                        <br>
                        <h5>Payment Information</h5>
                        <div class="row">
                            <div class="col">
                                <!-- Payment Method : {{this.paymentMethod}} -->
                                Payment Method : RazorPay
                            </div>
                        </div>
                    </div>
                </div>
    
                <!-- <div class="col-sm-1">
                </div> -->
            </div>
            <br>
            <div class="row col-md-3 box">
                <div class="col-lg-12">
                    <h5 class="text-left inq-cart-ord-ti-st">Payment Summary</h5>
                    <div class="row  inq-order-inner-p-st">
                        <table style="width: 100%;" class="table table-striped">
                            <ng-container>
                                <tr>
                                    <td>SubTotal</td>
                                    <td class="text-right">{{CONFIG.title === 'LuckMe' ||  CONFIG.title === 'Murgasen' ? 'SR ' : '₹'}} {{orderSummary.sub_total.toFixed(2)}}</td>
                                </tr>
                                <!-- <tr *ngIf="orderSummary.shipping_cost > 0">
                                    <td>Delivery Charge</td>
                                    <td class="text-right">{{CONFIG.title === 'LuckMe' ||  CONFIG.title === 'Murgasen' ? 'SR ' : '₹'}} {{orderSummary.shipping_cost .toFixed(2)}}</td>
                                </tr>
                                <tr *ngIf="orderSummary.packing_cost > 0">
                                    <td>{{orderSummary.handling_display}}</td>
                                    <td class="text-right">{{CONFIG.title === 'LuckMe' ||  CONFIG.title === 'Murgasen' ? 'SR ' : '₹'}} {{orderSummary.packing_cost}}</td>
                                </tr>
                                <tr *ngIf="orderSummary.discount_display !== ''&& CONFIG.title !== 'Carience' && CONFIG.title !== 'SpecialWires' && CONFIG.title !== 'Babys Pride' && CONFIG.title !== 'Vistas'">
                                    <td>{{orderSummary.discount_display}}</td>
                                    <td class="text-right">- {{CONFIG.title === 'LuckMe' ||  CONFIG.title === 'Murgasen'||  CONFIG.title === 'Murgasen' ? 'SR ' : '₹'}}{{orderSummary.discount_amount.toFixed(2)}}
                                    </td>
                                    
                                </tr>
                                <tr *ngIf="CONFIG.title == 'Carience'&& orderSummary.discount_amount !== ''">
                                    <td style="color:#0497a6">Discounts(-)</td>
                                    <td class="text-right" style="color:#0497a6">₹{{orderSummary.discount_amount.toFixed(2)}}
                                    </td>
                                    
                                </tr>
                                <tr *ngIf="CONFIG.title == 'SpecialWires'&& orderSummary.discount_amount !== ''&& orderSummary.discount_amount !== 0">
                                    <td style="color:#0497a6">Discounts(-)</td>
                                    <td class="text-right" style="color:#0497a6">₹{{orderSummary.discount_amount}}
                                    </td>
                                    
                                </tr>
                                <tr *ngIf="CONFIG.title == 'Vistas'&& orderSummary.discount_amount !== ''&& orderSummary.discount_amount !== 0">
                                    <td style="color:#0497a6">Discounts(-)</td>
                                    <td class="text-right" style="color:#0497a6">₹{{orderSummary.discount_amount}}
                                    </td>
                                    
                                </tr>
                                <tr *ngIf="CONFIG.title == 'Karupattiraja'&& orderSummary.discount_amount !== ''&& orderSummary.discount_amount !== 0 && orderSummary.discount_amount !== null && orderSummary.discount_amount !== undefined">
                                    <td style="color:#0497a6">Discounts(-)</td>
                                    <td class="text-right" style="color:#0497a6">₹{{orderSummary.discount_amount.toFixed(2)}}
                                    </td>
                                    
                                </tr>
                                <tr *ngIf="CONFIG.title == 'BestGifts'&& orderSummary.discount_amount !== ''&& orderSummary.discount_amount !== 0">
                                    <td style="color:#0497a6">Discounts(-)</td>
                                    <td class="text-right" style="color:#0497a6">₹{{orderSummary.discount_amount}}
                                    </td>
                                    
                                </tr>
                                <tr *ngIf="CONFIG.title == 'Babys Pride'&& orderSummary.discount_amount !== ''&& orderSummary.discount_amount !== 0">
                                    <td style="color:rgb(186 10 104)">Discounts(-)</td>
                                    <td class="text-right" style="color:rgb(186 10 104)">₹{{orderSummary.discount_amount}}
                                    </td>
                                    
                                </tr>
                                <tr *ngIf="CONFIG.title == 'Deera'&& orderSummary.discount_amount !== ''&& orderSummary.discount_amount !== 0">
                                    <td style="color:#2554C7">Discounts(-)</td>
                                    <td class="text-right" style="color:#2554C7">₹{{orderSummary.discount_amount}}
                                    </td>
                                    
                                </tr> -->
                                <tr *ngIf="(CONFIG.title !== 'BestGifts' && CONFIG.title !== 'Schift Cosmetics' && CONFIG.title !== 'Carience' && CONFIG.title !== 'LushNGreen')&& orderSummary.tax > 0">
                                    <td>Tax</td>
                                    <td class="text-right">{{CONFIG.title === 'LuckMe' ||  CONFIG.title === 'Murgasen' ? 'SR ' : '₹'}} {{orderSummary.tax}}</td>
                                </tr>
                                <tr>
                                    <td><strong>Total</strong></td>
                                    <td class="text-right"><strong>{{CONFIG.title === 'LuckMe' ||  CONFIG.title === 'Murgasen' ? 'SR ' : '₹'}}
                                            {{orderSummary.order_total_amount}}</strong>
                                    </td>
                                </tr>
                            </ng-container>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>
<!-- <div *ngIf="activateOrder === ''" style="min-height: 30vh; display: flex; justify-content: center; margin-top:100px">
    <h2>Please wait, Your data is loading...</h2>
</div>

<div *ngIf="activateOrder === 'failure'" style="min-height: 30vh; display: flex; justify-content: center; margin-top:100px">
    <h3>The order you are trying is invalid please go back to the checkout page.</h3>
</div> -->